import { PageHero } from "@/components/PageHero";
import { Stagger, StaggerItem } from "@/components/Reveal";
import { Wifi, Wind, Fan, Coffee, Droplets, Sparkles, Shirt, Wine, Waves, SprayCan } from "lucide-react";
import { IMG } from "@/data/site";

const amenities = [
  { icon: Wind, name: "Air Conditioning", desc: "Individually controlled climate in all rooms." },
  { icon: Fan, name: "Fan", desc: "Gentle island breeze on demand, in every room category." },
  { icon: Wine, name: "Minibar", desc: "Stocked minibar in all Superior Rooms." },
  { icon: Coffee, name: "Coffee Tray & Kettle", desc: "Coffee tray with kettle and hot water — Superior Rooms." },
  { icon: Droplets, name: "Hot Water", desc: "Reliable hot water showers throughout the hotel." },
  { icon: SprayCan, name: "Full Toiletries", desc: "Shampoo, conditioner, shower gel and soap in every bathroom." },
  { icon: Waves, name: "Hand Dryer Fan", desc: "In-room hand dryer fan in Superior Rooms." },
  { icon: Wifi, name: "High-Speed Wi-Fi", desc: "Complimentary in every room and public space." },
  { icon: Sparkles, name: "Daily Housekeeping", desc: "Immaculate rooms with fresh linens daily." },
  { icon: Shirt, name: "Laundry Service", desc: "Same-day laundry with in-room collection." },
];

export default function Amenities() {
  return (
    <div data-testid="amenities-page">
      <PageHero overline="Room Amenities" title="The details that matter" subtitle="Superior Rooms carry the full set — minibar, coffee tray, kettle and hand dryer fan. Standard Rooms keep the essentials." image={IMG.roomRomantic} />
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12">
        <Stagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {amenities.map((a) => (
            <StaggerItem key={a.name}>
              <div className="border hairline p-8 h-full hover:border-[#d4af37]/40 transition-colors duration-500">
                <a.icon size={24} className="text-[#d4af37] mb-5" />
                <h3 className="font-serif-display text-xl font-light text-white">{a.name}</h3>
                <p className="mt-2 text-sm text-[#a3a3a3]">{a.desc}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </section>
    </div>
  );
}
